import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { EditText } from '../../../../../../component/ui/edit-text/edit-text';
import { Dropdown } from 'primereact/dropdown';
import { updateExternalExamOperation } from '../operations/update-external-exam-operation';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import { AbstractExternalExam } from '../../../../../../api/types/settings/studies/abstract-external-exam';
import { Major } from '../../../../../../api/types/settings/studies/major';
import { PaymentServiceSelector } from '../../../../../external-exams/tabs/external-exam-groups/components/payment-service-selector';

interface EditExternalExamDialogProps {
  externalExam: AbstractExternalExam | null;
  onHide: () => void;
}

export const EditExternalExamDialog: React.FC<EditExternalExamDialogProps> = ({
  externalExam,
  onHide,
}) => {
  const [examName, setExamName] = useState('');
  const [symbol, setSymbol] = useState('');
  const [majorSymbol, setMajorSymbol] = useState('');
  const [selectedMajor, setSelectedMajor] = useState<Major | null>(null);
  const [paymentServiceId, setPaymentServiceId] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (externalExam) {
      setExamName(externalExam.examName);
      setSymbol(externalExam.symbol);
      setMajorSymbol(externalExam.majorSymbol || '');
      setPaymentServiceId(externalExam.paymentServiceId || null);
      const major = globalSettingsStores.majors.find(
        (m) => m.id === externalExam.majorId,
      );
      setSelectedMajor(major || null);
    }
  }, [externalExam]);

  const handleSave = async () => {
    if (!externalExam || !selectedMajor) {
      return;
    }
    await updateExternalExamOperation(
      externalExam.id,
      examName,
      symbol,
      majorSymbol,
      selectedMajor.id,
      paymentServiceId,
      setLoading,
      onHide,
    );
  };

  const isFormValid =
    examName.trim() &&
    symbol.trim() &&
    majorSymbol.trim() &&
    selectedMajor &&
    paymentServiceId !== null;

  const handleDialogHide = () => {
    if (!loading && externalExam) {
      setExamName(externalExam.examName);
      setSymbol(externalExam.symbol);
      setMajorSymbol(externalExam.majorSymbol || '');
      setPaymentServiceId(externalExam.paymentServiceId || null);
      const major = globalSettingsStores.majors.find(
        (m) => m.id === externalExam.majorId,
      );
      setSelectedMajor(major || null);
    }
    onHide();
  };

  const isVisible = Boolean(externalExam);

  return (
    <Dialog
      header="עריכת מבחן חיצוני"
      visible={isVisible}
      style={{
        width: '500px',
        backgroundColor: 'white',
        padding: '8px',
        borderRadius: '8px',
      }}
      onHide={handleDialogHide}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <EditText
          onChange={setExamName}
          value={examName}
          title={'שם המקצוע'}
          maxLength={50}
        />
        <EditText
          onChange={setSymbol}
          value={symbol}
          title={'סמל'}
          maxLength={50}
        />
        <EditText
          onChange={setMajorSymbol}
          value={majorSymbol}
          title={'סמל מגמה'}
          maxLength={50}
        />
        <div
          style={{
            flex: '1',
            minWidth: '250px',
            marginBottom: '16px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <label style={{ fontSize: '14px', color: '#4b5563' }}>מגמה</label>
          <Dropdown
            value={selectedMajor}
            onChange={(e) => setSelectedMajor(e.value)}
            options={globalSettingsStores.majors}
            optionLabel="majorName"
            placeholder="בחירת מגמה"
            style={{
              height: '36px',
              display: 'flex',
              alignItems: 'center',
              marginTop: '8px',
            }}
          />
        </div>
        <PaymentServiceSelector
          selectedPaymentServiceId={paymentServiceId}
          onPaymentServiceChange={(id, versionId) => {
            setPaymentServiceId(id);
          }}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '0.5rem',
          }}
        >
          <Button
            label="ביטול"
            severity="secondary"
            onClick={handleDialogHide}
            disabled={loading}
          />
          <Button
            label="שמירה"
            onClick={handleSave}
            loading={loading}
            disabled={!isFormValid}
          />
        </div>
      </div>
    </Dialog>
  );
};
